<template>
  <div>
  <div class="row">
    <div class="col-lg-4 col-sm-12 text-center">
      <h3>Plan</h3>
    </div>
    <div class="col-lg-4 col-sm-12 text-center">
      <h3>Act</h3>
    </div>
    <div class="col-lg-4 col-sm-12 text-center">
      <h3>Grow</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-4 col-sm-12">
      <book-card
          v-for="(book, index) in books.plan" :key="index"
          :image="book.img"
          :title="book.title"
          :shortDescription="book.shortDescription"
          :description="book.description"
          :onSubmit="downloadBook"
          :book="book">
      </book-card>
    </div>
    <div class="col-lg-4 col-sm-12">
      <book-card
          v-for="(book, index) in books.act" :key="index"
          :image="book.img"
          :title="book.title"
          :shortDescription="book.shortDescription"
          :description="book.description"
          :onSubmit="downloadBook"
          :book="book"
          disabled>
      </book-card>
    </div>
    <div class="col-lg-4 col-sm-12">
      <book-card
          v-for="(book, index) in books.grow" :key="index"
          :image="book.img"
          :title="book.title"
          :shortDescription="book.shortDescription"
          :description="book.description"
          :onSubmit="downloadBook"
          :book="book"
          disabled>
      </book-card>
    </div>
  </div>
  </div>
</template>

<script>
import Card from 'src/components/UIComponents/Cards/Card.vue'
import BookCard from 'src/components/UIComponents/Cards/BookCard.vue'

export default {
  data() {
    return {
      books: {
        plan: [
          {
            img: 'static/img/PlanEbookCover_small.png',
            title: 'Guide to Planning Your Career',
            description: '',
            shortDescription: 'Plan your work, work your plan, and crush your goals.',
            url: 'static/GuideToPlanningYourCareer.pdf'
          }
        ],
        act: [
          {
            img: 'static/img/GuideToAHigherBillRateCover_small.png',
            title: 'Guide to a Higher Bill Rate',
            description: '',
            shortDescription: 'How to provide and capture more value as a freelance software developer.'
          },
          {
            img: 'static/img/KickAssFreelancerCover_small.png',
            title: 'How to Be a Kick-Ass Freelancer',
            description: '',
            shortDescription: 'Delight your clients, build your reputation, and stand out from the crowd.'
          }
        ],
        grow: [
          {
            img: 'static/img/GuideToWinningMoreContractsCover_small.png',
            title: 'Guide to Winning More Contracts',
            description: '',
            shortDescription: 'Leverage your strengths, target your ideal clients, and send a winning proposal.'
          },
          {
            img: 'static/img/FreelancerToEntrepreneurCover_small.png',
            title: 'From Freelancer to Entrepreneur',
            description: '',
            shortDescription: 'Turn your development knowledge into a scalable business to make money even when you\'re not working'
          }
        ]
      },
    };
  },
  methods: {
    downloadBook (book) {
      window.open(book.url, "_new");
    }
  },
  components: {
    Card,
    BookCard
  }
};
</script>
